// src/artwork/index.js — 🎨 the shared illustration set (v129.50).
//
// The rest of the approved artwork rollout (Matt, 4 Aug): the empty-state
// illustrations and small supporting art that don't belong to any one feature
// bundle. Same rules as src/achievements/art.js: plain SVG geometry, no
// gradients beyond flat tints, no external requests, TE brand hues from
// assets/brand-src, and the TE/ELC MARKS are never drawn here.
//
// Every consumer guards with `typeof Artwork !== 'undefined'` and keeps its
// emoji fallback — an unloaded bundle degrades to exactly what shipped before.

var HUE = {
  red: '#DA291C', blue: '#1B75BC', sky: '#00C1DE', teal: '#00B2A9',
  green: '#009E3D', toygreen: '#00B140', orange: '#E87722', sun: '#FFB81C',
  purple: '#981D97', cloud: '#EAF2F7', basketw: '#F6E6C8', basket: '#C77B41',
};

// ── the hot-air balloon (from the TE flagship motif) — the "nothing has
// landed yet" illustration for an empty inbox ────────────────────────────────
function balloonSvg(size) {
  size = size || 96;
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="hot air balloon">' +
    '<ellipse cx="24" cy="24" rx="12" ry="6" fill="' + HUE.cloud + '"/>' +
    '<ellipse cx="80" cy="38" rx="10" ry="5" fill="' + HUE.cloud + '"/>' +
    '<path d="M50 8 a26 28 0 0 1 26 28 c0 14 -14 22 -18 28 h-16 c-4 -6 -18 -14 -18 -28 a26 28 0 0 1 26 -28 Z" fill="' + HUE.red + '"/>' +
    '<path d="M50 8 a26 28 0 0 0 -10 54 c-4 -16 -4 -40 4 -53 a26 28 0 0 0 -8 2 Z" fill="' + HUE.sun + '" opacity=".9"/>' +
    '<path d="M50 8 a26 28 0 0 1 10 54 c4 -16 4 -40 -4 -53 a26 28 0 0 1 8 2 Z" fill="' + HUE.sky + '" opacity=".9"/>' +
    '<path d="M42 64 l-3 10 M58 64 l3 10" stroke="' + HUE.basket + '" stroke-width="2.5"/>' +
    '<rect x="38" y="73" width="24" height="15" rx="4" fill="' + HUE.basketw + '" stroke="' + HUE.basket + '" stroke-width="2.5"/>' +
    '</svg>';
}

// ── the train (the flagship train motif) — "all done / next one's coming" ───
function trainSvg(size) {
  size = size || 96;
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="toy train">' +
    '<circle cx="76" cy="26" r="4" fill="' + HUE.cloud + '"/><circle cx="83" cy="19" r="5.5" fill="' + HUE.cloud + '"/>' +
    '<rect x="14" y="42" width="26" height="26" rx="4" fill="' + HUE.red + '"/>' +
    '<rect x="18" y="30" width="12" height="14" rx="2.5" fill="' + HUE.red + '"/>' +
    '<rect x="20" y="33" width="8" height="7" rx="1.5" fill="' + HUE.sky + '"/>' +
    '<rect x="40" y="50" width="18" height="18" rx="3" fill="' + HUE.sun + '"/>' +
    '<rect x="60" y="50" width="18" height="18" rx="3" fill="' + HUE.toygreen + '"/>' +
    '<rect x="66" y="34" width="8" height="16" rx="3" fill="' + HUE.blue + '"/>' +
    '<rect x="10" y="68" width="72" height="4" rx="2" fill="' + HUE.basket + '"/>' +
    '<circle cx="24" cy="74" r="6" fill="#20241f"/><circle cx="24" cy="74" r="2.5" fill="#fff"/>' +
    '<circle cx="49" cy="74" r="5" fill="#20241f"/><circle cx="49" cy="74" r="2" fill="#fff"/>' +
    '<circle cx="69" cy="74" r="5" fill="#20241f"/><circle cx="69" cy="74" r="2" fill="#fff"/>' +
    '</svg>';
}

// ── the streak flame + kudos clap (the gallery's supporting roundels) ───────
function flameSvg(size) {
  size = size || 20;
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="streak" style="vertical-align:-3px">' +
    '<path d="M52 10 c3 16 19 22 19 41 a21 21 0 0 1 -42 0 c0 -13 8 -18 10 -29 c5 5 8 11 7 19 c5 -5 8 -16 6 -31 Z" fill="' + HUE.orange + '"/>' +
    '<circle cx="50" cy="56" r="9" fill="' + HUE.sun + '"/></svg>';
}
function clapSvg(size) {
  size = size || 20;
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="kudos" style="vertical-align:-3px">' +
    '<circle cx="50" cy="50" r="46" fill="' + HUE.toygreen + '"/>' +
    '<g fill="#fff"><rect x="30" y="40" width="10" height="26" rx="5" transform="rotate(-15 35 53)"/>' +
    '<rect x="44" y="34" width="10" height="32" rx="5"/>' +
    '<rect x="58" y="40" width="10" height="26" rx="5" transform="rotate(15 63 53)"/>' +
    '<path d="M28 30 l-5 -6 M50 24 v-8 M72 30 l5 -6" stroke="#fff" stroke-width="4" stroke-linecap="round" fill="none"/></g></svg>';
}

// ── the six induction-module roundels (My Development) ──────────────────────
// One hue + glyph per module, in course order. Not-done renders the same
// roundel greyed with the number — progress you can SEE filling in, which is
// the entire point over a row of ticks.
var MODULES = [
  { hue: HUE.red, g: '<path d="M50 22 c10 8 12 22 8 34 h-16 c-4 -12 -2 -26 8 -34 Z"/><polygon points="42,56 32,66 42,64"/><polygon points="58,56 68,66 58,64"/>' },              // 1 welcome/launch
  { hue: HUE.sky, g: '<path d="M50 32 c-6 -5 -16 -5 -22 -2 v36 c6 -3 16 -3 22 2 c6 -5 16 -5 22 -2 V30 c-6 -3 -16 -3 -22 2 Z"/>' },                                              // 2 knowledge
  { hue: HUE.sun, g: '<circle cx="38" cy="44" r="9"/><circle cx="62" cy="44" r="9"/><path d="M30 68 c6 -8 34 -8 40 0" fill="none" stroke="#fff" stroke-width="6" stroke-linecap="round"/>' }, // 3 customers
  { hue: HUE.teal, g: '<rect x="28" y="46" width="44" height="22" rx="4"/><path d="M40 46 v-8 a10 10 0 0 1 20 0 v8" fill="none" stroke="#fff" stroke-width="6"/>' },              // 4 security/tills
  { hue: HUE.purple, g: '<rect x="30" y="52" width="10" height="16" rx="2"/><rect x="45" y="42" width="10" height="26" rx="2"/><rect x="60" y="32" width="10" height="36" rx="2"/>' }, // 5 selling
  { hue: HUE.green, g: '<path d="M30 52 l14 14 26 -30" fill="none" stroke="#fff" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>' },                            // 6 sign-off
];
function moduleRoundel(i, done, size) {
  size = size || 34;
  var m = MODULES[i] || MODULES[0];
  if (!done) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="module ' + (i + 1) + ' not yet done">' +
      '<circle cx="50" cy="50" r="46" fill="#E9E9EB"/>' +
      '<text x="50" y="63" text-anchor="middle" font-size="38" font-weight="700" fill="#B5B5BA" font-family="inherit">' + (i + 1) + '</text></svg>';
  }
  var n = parseInt(m.hue.slice(1), 16);
  var rim = 'rgb(' + Math.round(((n >> 16) & 255) * .72) + ',' + Math.round(((n >> 8) & 255) * .72) + ',' + Math.round((n & 255) * .72) + ')';
  return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 100 100" role="img" aria-label="module ' + (i + 1) + ' complete">' +
    '<circle cx="50" cy="50" r="46" fill="' + m.hue + '"/>' +
    '<circle cx="50" cy="50" r="46" fill="none" stroke="' + rim + '" stroke-width="4"/>' +
    '<g fill="#fff">' + m.g + '</g></svg>';
}

export { balloonSvg, trainSvg, flameSvg, clapSvg, moduleRoundel };
